import { SURVEY_SECTIONS } from './constants';

/**
 * Groups survey questions into the Surveys page sections, in `SURVEY_SECTIONS` order. Every section
 * is returned, empty or not; questions of other types are dropped.
 * @param {Object[]} questions `survey_questions` rows
 * @returns {{ id: string, title: string, items: Object[], emptyText: string }[]}
 */
export const groupSurveyQuestions = (questions = []) =>
    SURVEY_SECTIONS.map(({ type, title }) => ({
        id: type,
        title,
        items: questions.filter((question) => question.survey_type === type),
        emptyText: `No ${title.toLowerCase()} set up.`,
    }));
